const Campaign = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign')
const Pricelist = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist')
const Static = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Static')

// const AirlinesPriceList = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Airlines/PriceList')
const AirlinesPriceListDetail = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Airlines/PriceList/Detail')
const AirlinesPriceListTnC = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Airlines/PriceList/TnC')
const AirlinesPriceListFuturePrices = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Airlines/PriceList/FuturePrices')

// Outdoor Price List
const OutdoorPriceList = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Outdoor')
const OutdoorDetail = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Outdoor/Detail')
const OutdoorContentRest = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Outdoor/ContentRestriction')
const OutdoorFuturePrice = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Outdoor/FuturePrice')
const OutdoorAdress = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Outdoor/Address')
const OutdoorImages = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Outdoor/Images')

// Bus Price List
const BusPriceList = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Bus')
const BusDetail = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Bus/Detail')
const BusPricing = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Bus/Pricing')
const BusRouteDetail = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Bus/RouteDetail')
const BusVehicle = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Bus/Vehicle')

// Airlines Price List
const AirlinesPriceList = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Airlines')
const AirlinesDetail = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Airlines/Detail')
const AirlinesContentRest = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Airlines/ContentRestriction')
const AirlinesFuturePrice = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Airlines/FuturePrices')
const AirlinesAdress = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Airlines/Address')
const AirlinesImages = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Pricelist/Airlines/Images')

// Lifestyle Price List
const LifestylePriceList = () => import(/* webpackChunkName: "LifestylePriceList" */ '../views/Campaign/Pricelist/Lifestyle')
const LifestyleDetail = () => import(/* webpackChunkName: "LifestyleDetail" */ '../views/Campaign/Pricelist/Lifestyle/Detail')
const LifestyleItemDetails = () => import(/* webpackChunkName: "LifestyleContentRest" */ '../views/Campaign/Pricelist/Lifestyle/ItemDetails')
const LifestyleLocationDetails = () => import(/* webpackChunkName: "LifestyleAdress" */ '../views/Campaign/Pricelist/Lifestyle/LocationDetails')
const LifestylePricing = () => import(/* webpackChunkName: "LifestyleFuturePrice" */ '../views/Campaign/Pricelist/Lifestyle/Pricing')
const LifestyleImages = () => import(/* webpackChunkName: "LifestyleImages" */ '../views/Campaign/Pricelist/Lifestyle/Images')

// const CampaignEditorEdit = () => import(/* webpackChunkName: "CampaignEditorEdit" */ '../views/Campaign/CampaignEditor')
const CampaignEditorEdit = () => import(/* webpackChunkName: "CampaignEditorEdit" */ '../views/Campaign/CampaignEditorV2')
const CampaignDraftDraft = () => import(/* webpackChunkName: "CampaignDraftDraft" */ '../views/Campaign/CampaignDraft')

//Quotations
const QuotationsList = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Quotation')
const QuotationEditor = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Quotation/QuotationEditor')
const QuotationEdit = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Quotation/Edit')
const QuotationSummary = () => import(/* webpackChunkName: "Admin" */ '../views/Campaign/Quotation/QuotationSummary')


const campaignRouter = [
  {
    path: '/campaign',
    name: 'campaign',
    component: Campaign,
    redirect: { name: 'pricelist' },
    meta: { isStaff: true },
    children: [
      {
        path: '/campaign/pricelist',
        name: 'pricelist',
        component: Pricelist,
        redirect: { name: 'airlinespricelist' },
        meta: { isStaff: true },
        children: [
          {
            path: '/campaign/pricelist/outdoor',
            name: 'outdoorpricelist',
            component: OutdoorPriceList,
            // redirect: { name: 'outdoordetail' },
            meta: { isStaff: true },
            children: [
              {
                path: '/campaign/pricelist/outdoor/detail',
                name: 'outdoordetail',
                component: OutdoorDetail,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/outdoor/tnc',
                name: 'outdoorcontentrest',
                component: OutdoorContentRest,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/outdoor/future-prices',
                name: 'outdoorfutureprice',
                component: OutdoorFuturePrice,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/outdoor/address',
                name: 'outdooradress',
                component: OutdoorAdress,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/outdoor/images',
                name: 'outdoorimages',
                component: OutdoorImages,
                meta: { isStaff: true }
              }
            ]
          },
          {
            path: '/campaign/pricelist/bus',
            name: 'buspricelist',
            component: BusPriceList,
            // redirect: { name: 'outdoordetail' },
            meta: { isStaff: true },
            children: [
              {
                path: '/campaign/pricelist/bus/detail',
                name: 'busdetail',
                component: BusDetail,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/bus/pricing',
                name: 'buspricing',
                component: BusPricing,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/Bus/routedetail',
                name: 'busroutedetail',
                component: BusRouteDetail,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/bus/vehicle',
                name: 'busvehicle',
                component: BusVehicle,
                meta: { isStaff: true }
              }
            ]
          },
          {
            path: '/campaign/pricelist/airlines',
            name: 'airlinespricelist',
            component: AirlinesPriceList,
            // redirect: { name: 'airlinesdetail' },
            meta: { isStaff: true },
            children: [
              {
                path: '/campaign/pricelist/airlines/detail',
                name: 'airlinesdetail',
                component: AirlinesDetail,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/airlines/tnc',
                name: 'airlinescontentrest',
                component: AirlinesContentRest,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/airlines/future-prices',
                name: 'airlinesfutureprice',
                component: AirlinesFuturePrice,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/airlines/address',
                name: 'airlinesadress',
                component: AirlinesAdress,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/airlines/images',
                name: 'airlinesimages',
                component: AirlinesImages,
                meta: { isStaff: true }
              }
            ]
          },
          {
            path: '/campaign/pricelist/lifestyle',
            name: 'lifestylepricelist',
            component: LifestylePriceList,
            // redirect: { name: 'lifestyledetail' },
            meta: { isStaff: true },
            children: [
              {
                path: '/campaign/pricelist/lifestyle/detail',
                name: 'lifestyledetail',
                component: LifestyleDetail,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/lifestyle/item-details',
                name: 'lifestyleitemdetails',
                component: LifestyleItemDetails,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/lifestyle/location-details',
                name: 'lifestylelocationdetails',
                component: LifestyleLocationDetails,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/lifestyle/pricing',
                name: 'lifestylepricing',
                component: LifestylePricing,
                meta: { isStaff: true }
              },
              {
                path: '/campaign/pricelist/lifestyle/images',
                name: 'lifestyleimages',
                component: LifestyleImages,
                meta: { isStaff: true }
              }
            ]
          }
        ]
      },
      {
        path: '/campaign/quotation',
        name: 'quotationlist',
        component: QuotationsList,
        meta: { isStaff: true }
      },
      {
        path: '/campaign/quotation/edit/:id',
        name: 'quotationedit',
        component: QuotationEdit,
        meta: { isStaff: true }
      },
      {
        path: '/campaign/quotation-summary/:id',
        name: 'quotationsummary',
        component: QuotationSummary,
        meta: { isStaff: true }
      },
      {
        path: '/campaign/quotation-editor/:id',
        name: 'quotationeditor',
        component: QuotationEditor,
        meta: { isStaff: true }
      },
      {
        path: '/campaign/draftcampaign',
        name: 'draftcampaign',
        component: CampaignDraftDraft,
        meta: { isStaff: true }
      },
    ],
  },
  {
    path: '/editorcampaign/:id/',
    name: 'campaigneditoredit',
    component: CampaignEditorEdit,
    meta: { isStaff: true }
  },
]

export default campaignRouter;
